import { Paths } from "@/core/constants/paths";
import { HUB_PERMISSOES } from "@/modules/permissoes";
import type { HubClaim } from "@/modules/permissoes";

export const FINANCEIRO_TITLE = "Financeiro";
export const FINANCEIRO_TABS_LABEL = "Abas do Financeiro";
export const FINANCEIRO_SUBABAS_LABEL = "Configurações do Financeiro";
export const FINANCEIRO_CARREGANDO_LABEL = "Carregando configurações...";
export const FINANCEIRO_SEM_PERMISSAO_DESCRIPTION =
  "Você não tem permissão para acessar as configurações do Financeiro.";

/** As abas viram um seletor ao lado do título, como em Recursos. */
export const FINANCEIRO_MOBILE_QUERY = "(max-width: 768px)";

export interface AbaFinanceiro {
  readonly label: string;
  readonly to: string;
  /** Claim que libera a aba; sem ela a aba fica sempre visível (o acesso é decidido pela API). */
  readonly claim?: HubClaim;
}

/** Abas do Financeiro, na ordem de exibição. */
export const FINANCEIRO_ABAS: readonly AbaFinanceiro[] = [
  { label: "Obras", to: Paths.FINANCEIRO_OBRAS },
  {
    label: "Configurações",
    to: Paths.FINANCEIRO_CONFIGURACOES,
    claim: HUB_PERMISSOES.FINANCEIRO_VIEW_CONFIGURACAO,
  },
];

/**
 * Sub-abas de Configurações, com a claim de cada uma. Quem entra depois (Curvas, Distribuições, Escopos macro padrão,
 * Base de dados) acrescenta a linha aqui, sem mexer no shell.
 */
export const FINANCEIRO_CONFIGURACOES_SUBABAS: readonly (AbaFinanceiro & { claim: HubClaim })[] = [
  {
    label: "Curvas",
    to: Paths.FINANCEIRO_CONFIGURACOES_CURVAS,
    claim: HUB_PERMISSOES.FINANCEIRO_VIEW_CONFIGURACAO,
  },
  {
    label: "Distribuições",
    to: Paths.FINANCEIRO_CONFIGURACOES_DISTRIBUICOES,
    claim: HUB_PERMISSOES.FINANCEIRO_VIEW_CONFIGURACAO,
  },
  {
    label: "Escopos macro padrão",
    to: Paths.FINANCEIRO_CONFIGURACOES_ESCOPOS_PADRAO,
    claim: HUB_PERMISSOES.FINANCEIRO_VIEW_CONFIGURACAO,
  },
  {
    label: "Base de dados",
    to: Paths.FINANCEIRO_CONFIGURACOES_BASE_DADOS,
    claim: HUB_PERMISSOES.FINANCEIRO_VIEW_CONFIGURACAO,
  },
  {
    label: "Moedas",
    to: Paths.FINANCEIRO_CONFIGURACOES_MOEDAS,
    claim: HUB_PERMISSOES.FINANCEIRO_VIEW_CONFIGURACAO,
  },
];
